<template>
  <div class="right-toolbar">
    <div class="tool-item" @click="typeShow = !typeShow">
      <span style="font-size: 20px;">{{ projectData.tubeClassCode }}</span>
      <div class="project-type-popup" v-show="typeShow">
        <a-list size="small" item-layout="horizontal" :data-source="typeList">
          <a-list-item slot="renderItem" slot-scope="item, index" @click="toggleType(item)">
            <div style="padding-left: 10px;"> {{ item.tubeClassName }} ({{ item.tubeClassCode }})</div>
          </a-list-item>
        </a-list>
      </div>
    </div>
    <div class="tool-item" @click="toggleFullscreen">
      <img :src="require(`@/assets/collect/${isFullscreen ? 'exitfullscreen.svg' : 'fullscreen.svg'}`)"
        :alt="isFullscreen ? '退出全屏' : '全屏'" :title="isFullscreen ? '退出全屏' : '全屏'">
    </div>
    <div class="tool-item" @mouseenter="showProjectInfo" @mouseleave="hideProjectInfo">
      <img src="@/assets/collect/projectInfo.svg" alt="项目信息" title="项目信息">
      <!-- 项目信息弹窗 -->
      <div class="project-info-popup" v-show="projectInfoVisible">
        <div class="info-item">
          <span class="label">项目：</span>
          <span class="value">{{ projectInfo.projectName }}</span>
        </div>
        <div class="info-item">
          <span class="label">创建时间：</span>
          <span class="value">{{ projectInfo.createTime }}</span>
        </div>
      </div>
    </div>
    <div class="tool-item" @click="toggleLuminance">
      <img :src="require(`@/assets/collect/${isLuminances ? 'day.svg' : 'night.svg'}`)" alt="亮度切换" title="亮度切换">
    </div>
  </div>
</template>

<script>
export default {
  name: 'RightToolbarModule',
  props: {
    typeList: Array, //类型列表
    projectData: Object, //当前类型
    isLuminance: Boolean,
    projectInfo: {
      type: Object,
      default: () => ({
        userName: '',
        phone: '',
        projectName: '',
        type: '',
        createTime: ''
      })
    }
  },
  watch: {
    isLuminance: {
      immediate: true,
      handler (val) {
        console.log(val);
        this.isLuminances = val;
      }
    },
  },
  created () {
    console.log(this.projectData);

  },
  data () {
    return {
      isFullscreen: false,
      typeShow: false,
      projectInfoVisible: false,
      isLuminances: false,
    }
  },
  methods: {
    toggleLuminance () {
      this.isLuminances = !this.isLuminances
      this.$emit('update:isLuminance', this.isLuminances);
    },
    toggleFullscreen () {
      const element = document.querySelector('.pipeline-mapping')
      if (!document.fullscreenElement) {
        element.requestFullscreen()
        this.isFullscreen = true
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
          this.isFullscreen = false
        }
      }
    },
    showProjectInfo () {
      this.projectInfoVisible = true
    },
    hideProjectInfo () {
      this.projectInfoVisible = false
    },
    toggleType (item) {
      console.log(item);


      // 触发事件，将新值传递给父组件
      this.$emit('update:projectData', {
        tubeClassSettingId: item.id,
        tubeClassCode: item.tubeClassCode,
      });
    }
  },
  mounted () {
    // 监听全屏变化
    document.addEventListener('fullscreenchange', () => {
      this.isFullscreen = !!document.fullscreenElement
    })
  },
  beforeDestroy () {
    document.removeEventListener('fullscreenchange', () => {
      this.isFullscreen = !!document.fullscreenElement
    })
  }
}
</script>

<style lang="less" scoped>
.right-toolbar {
  display: flex;
  align-items: center;
  height: 48px;
  padding: 0 12px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  .tool-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    margin: 0 4px;
    cursor: pointer;
    transition: background 0.3s;
    border-radius: 4px;

    &:hover {
      background-color: #f0f0f0;
    }

    img {
      width: 20px;
      height: 20px;
    }

    .project-type-popup {
      position: absolute;
      top: 135%;
      left: -24%;
      z-index: 1001;
      width: 128px;
      border-radius: 4px;
      background: #fff;
    }

    .project-info-popup {
      position: absolute;
      top: 100%;
      right: 0;
      margin-top: 8px;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      padding: 16px;
      width: 300px;
      z-index: 1001;

      &::before {
        content: '';
        position: absolute;
        top: -6px;
        right: 12px;
        width: 12px;
        height: 12px;
        background: #fff;
        transform: rotate(45deg);
        box-shadow: -2px -2px 5px rgba(0, 0, 0, 0.05);
      }

      .info-item {
        margin-bottom: 12px;
        display: flex;
        align-items: center;

        &:last-child {
          margin-bottom: 0;
        }

        .label {
          width: 80px;
          color: rgba(0, 0, 0, 0.65);
        }

        .value {
          color: rgba(0, 0, 0, 0.85);
          font-weight: 500;
        }
      }
    }
  }
}
</style>